import { AuthService } from "@services/authService"
import { useQuery } from "@tanstack/react-query"

export const useQAMode = () => {
	const {
		data: isQAMode = false,
		isLoading,
		error
	} = useQuery({
		queryKey: ["qa-mode"],
		queryFn: AuthService.getQAModeStatus,
		staleTime: 5 * 60 * 1000,
		gcTime: 10 * 60 * 1000,
		refetchOnWindowFocus: false,
		retry: 1
	})

	return {
		isQAMode,
		isLoading,
		error
	}
}
